"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
exports.queue = rxjs_1.queueScheduler;
//# sourceMappingURL=queue.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs-compat/scheduler/queue.js
// module id = 1339
// module chunks = 0